var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 120,
    viewBox: "0 0 157 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    width: 104,
    height: 104,
    rx: 10,
    fill: "#077CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 42.9948H78C76.35 42.9948 75 41.6448 75 39.9948C75 38.3448 76.35 36.9948 78 36.9948H87C88.65 36.9948 90 38.3448 90 39.9948C90 41.6448 88.65 42.9948 87 42.9948ZM87 51.9948H78C76.35 51.9948 75 53.3448 75 54.9948C75 56.6448 76.35 57.9948 78 57.9948H87C88.65 57.9948 90 56.6448 90 54.9948C90 53.3448 88.65 51.9948 87 51.9948ZM128.64 70.8648L119.28 61.5048C116.7 63.1848 113.61 64.1448 110.28 63.9648C103.17 63.6348 97.08 58.0848 96.12 51.0348C94.8 40.9848 103.47 32.4948 113.61 34.2048C119.46 35.1948 124.32 39.7548 125.61 45.5448C126.6 49.9248 125.64 54.0048 123.51 57.2448L132.9 66.6348C134.07 67.8048 134.07 69.6948 132.9 70.8648C131.73 72.0348 129.81 72.0348 128.64 70.8648ZM120 48.9948C120 44.0448 115.95 39.9948 111 39.9948C106.05 39.9948 102 44.0448 102 48.9948C102 53.9448 106.05 57.9948 111 57.9948C115.95 57.9948 120 53.9448 120 48.9948ZM78 72.9948H102C103.65 72.9948 105 71.6448 105 69.9948C105 68.3448 103.65 66.9948 102 66.9948H78C76.35 66.9948 75 68.3448 75 69.9948C75 71.6448 76.35 72.9948 78 72.9948Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9414 118.739L24.8416 109.079L19.3214 103.559L17.9414 118.739Z",
    fill: "#C8FA5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8808 120L0 84.4605L69.0016 61L35.8808 120Z",
    fill: "#97D318"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0003 61L10.2227 94.5872L17.9391 118.961L19.3345 103.612L69.0003 61Z",
    fill: "#84B320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentPlane);
export default __webpack_public_path__ + "static/media/sent_plane.8b60c6bae9ccc1431f7c32ca2be3b549.svg";
export { ForwardRef as ReactComponent };